import { Text, Flex, Link } from '@chakra-ui/react';
import ConfirmModal from '../../../common/ConfirmModal';

const RequestChangesModal = ({
  isOpen,
  onClose,
  onOpenDeclineModal,
  onOpenForm,
}) => {
  const handleClose = () => {
    onClose();
  };

  const handleStayOnPlan = () => {
    handleClose();
    onOpenDeclineModal();
  };

  const handleRequestChanges = () => {
    handleClose();
    onOpenForm?.();
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={handleClose}
      title="Request plan changes"
      description={
        "Tell us what you'd like to change and we'll update the plan for you. Your current plan will stay active until you accept a new one."
      }
      primaryButton={{
        label: 'Request changes',
        onClick: handleRequestChanges,
      }}
      secondaryButton={{
        label: 'Cancel',
        onClick: handleClose,
      }}
      textBelowButtons={
        <Text textStyle="bodyFamilyRegular" fontSize="14px" textAlign="center">
          Changed your mind?{' '}
          <Link onClick={handleStayOnPlan} textDecoration="underline">
            Keep current plan
          </Link>
        </Text>
      }
      horizontalButtons={true}
    ></ConfirmModal>
  );
};

export default RequestChangesModal;
